import { useReveal } from "@/hooks/useReveal";

const ITEMS = [
  {
    icon: "ri-drop-line",
    title: "Unrefined, not bleached",
    body: "Cane juice evaporated without centrifuging, so the natural molasses stays in the crystal. It reads as amber-gold rather than white, and it tastes of cane rather than of nothing.",
  },
  {
    icon: "ri-leaf-line",
    title: "A story the barista can tell in ten seconds",
    body: "Grown by smallholder cooperatives in Quindío, in Colombia's coffee region, under certified organic practice. Traceable to the growing region, not to an anonymous refinery.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Certified in a way that holds up",
    body: "Ecocert USDA Organic and EU Organic, HACCP, INVIMA. South Africa has no national organic regulation, so these seals are used as they are, with no equivalence procedure.",
  },
  {
    icon: "ri-pie-chart-line",
    title: "Cost per serving you can plan",
    body: "Fixed portion weight per sachet means the cost per cup served is predictable, not estimated from a bulk bowl that customers overfill.",
  },
];

export default function TheSachet() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section id="sachet" className="bg-cream py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={ref} className="reveal max-w-2xl">
          <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
            Start with the sachet
          </h2>
          <p className="mt-4 text-ink/70 text-lg leading-relaxed">
            It is the smallest line on your beverage cost sheet and one of the
            few things every single customer touches. Swapping refined white
            sugar for a certified organic, unrefined one changes what the
            counter says about the business, at a cost per serving you can
            control.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-6">
          {ITEMS.map((item) => (
            <div
              key={item.title}
              className="bg-white rounded-lg p-7 border border-cream-dark/60"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-cream text-brown">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="mt-4 text-ink font-serif text-lg md:text-xl font-semibold">
                {item.title}
              </h3>
              <p className="mt-2 text-ink/70 text-[17px] leading-relaxed">
                {item.body}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 border border-brown/30 rounded-lg bg-white px-6 py-5">
          <p className="text-ink/80 text-[17px] leading-relaxed">
            Also known as non-centrifugal cane sugar (NCS), whole cane sugar,
            unrefined cane sugar, muscovado-type, jaggery, or panela in Latin
            America.
          </p>
        </div>
      </div>
    </section>
  );
}